import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

export const Upgrade = () => {
  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.projects}
      featureRequested={Features.projects_logs}
      requestSource={ProjectsUpsellRequestSources.projectLog}
      requestReason={ValidReasons.MissingFeature}
      learnMoreNavigate={{
        url: 'https://help.factorialhr.com/tasks-projects',
        isExternal: true,
      }}
      title={i18n.t('project_management.upselling.title')}
      description={i18n.t('project_management.upselling.activity_log')}
      buttonLabel={i18n.t('project_management.upselling.cta')}
      variant="table"
    />
  )
}
